import { render, staticRenderFns } from "./NewReservations.vue?vue&type=template&id=f8669e20"
import script from "./NewReservations.vue?vue&type=script&lang=js"
export * from "./NewReservations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports